// const axios = require('axios');
// const axiosRetry = require('axios-retry');
// const routeService = require('./routeService');

import axios from 'axios';
import axiosRetry from 'axios-retry';
import routeService from './routeService';
import PersistentCache from '../utility/PersistentCache';
const PROD_URL = 'https://api.mapbox.com/optimized-trips/v2';
const STAGING_URL =
  'https://vorpal-sword-staging.tilestream.net/optimized-trips/v2/';

// const stopIDs = [103];
// const stops = dataService.getRouteById('103');
const token =
  process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ||
  'pk.eyJ1IjoieXVsZXRpZGUiLCJhIjoiY2s3cHMyeWxtMDQwaDNmbXZkeTlvMnRmayJ9.mkYPHtQ5iLxGEufBPKOsBg';
const params = { access_token: token, cpu_budget: 3 };
/**
 * Makes requests to the Mapbox Optmizer v2
 * Documentatio: https://docs.google.com/document/d/1sBQ-TN82lKoCjrPpTzvqOAit0__uEuUhGWUQRm_psJk/edit#
 */
class OptimizationService {
  client = axios.create({
    baseURL: STAGING_URL,
    // baseURL: PROD_URL,
    // params: { access_token: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN }, // not working. https://github.com/axios/axios/issues/2190
  });
  optimizedRouteCache = new PersistentCache('optimizedRouteCache');

  buildJSON = stops => {
    const locations = [
      {
        name: 'depot49',
        coordinates: [-71.06128692626953, 42.355499492256534],
      },
      // {
      //   // from DepotDetails.tsv
      //   // TODO load this from the active depot
      //   name: 'depot49',
      //   coordinates: [-1.092791, 53.987253],
      // },
    ];
    const shipments = [];

    stops.map(stop => {
      locations.push({
        name: stop.id,
        coordinates: stop.geometry.coordinates,
      });
      // TODO create a shipment for each parcel
      shipments.push({
        name: stop.id,
        from: 'depot49',
        to: stop.id,
        dropoff_duration: 60,
      });
    });

    let json = {
      version: 1,
      vehicles: [
        {
          name: 'truck',
        },
      ],
      locations,
      shipments,
      // locations: [
      //   {
      //     name: '123',
      //     coordinates: [-122.1234, 37.812],
      //   },
      //   {
      //     name: '124',
      //     coordinates: [-123.1334, 38.813],
      //   },
      //   {
      //     name: 'warehouse',
      //     coordinates: [-122.1334, 38],
      //   },
      // ],
      // shipments: [
      //   {
      //     name: 'order-1',
      //     from: 'warehouse',
      //     to: '123',
      //   },
      //   {
      //     name: 'order-2',
      //     from: 'warehouse',
      //     to: '124',
      //   },
      // ],
    };
    return json;
  };
  // From https://github.com/mapbox/frontend-optimized-trips/blob/master/src/formats/vrp.js#L4
  joinProblemSolution(problem, solution) {
    if (!problem || !solution) {
      return {};
    }
    const locations = {};
    for (let location of problem.locations) {
      locations[location.name] = location.coordinates;
    }
    const joined = Object.assign({}, solution);
    for (let route of joined.routes) {
      for (let stop of route.stops) {
        stop.coordinates = locations[stop.location];
      }
    }
    return joined;
  }

  // this optimizes one route at a time, taking in a route object
  optimizeRoute = async route => {
    // const stops = route.stops || route;
    const problem = this.buildJSON(route.stops);
    const problemKey = JSON.stringify(problem);
    // initialize request for problem
    const cached = this.optimizedRouteCache.get(problemKey);
    if (cached) {
      console.log('found cached response', cached);
      await new Promise(resolve => {
        setTimeout(resolve, 2000);
      });
      return cached;
    }
    const resp = await this.client.post('', problem, {
      params,
    });
    const submitTime = new Date();
    console.log(resp);
    if (resp.status === 202) {
      console.log('Problem submitted', resp.data);
      const optResult = await this.getOptimizeResult(resp.data.id);
      const solution = this.joinProblemSolution(problem, optResult);
      console.log(
        `Solution found in ${(new Date() - submitTime) / 1000} seconds`
      );

      // set duration and distance from solution
      const solutionStops = solution.routes[0].stops;
      const finalStop = solutionStops[solutionStops.length - 1];
      const distance = finalStop.odometer; // distance in meters
      const duration =
        (new Date(finalStop.eta) - new Date(solutionStops[0].eta)) / 1000; // UI expects secs

      // ROUTES
      // console.log('joined', joined);
      const routeSubmitTime = new Date();
      const directionsResult = await routeService.processSolution(solution);
      console.log(`Route found in ${(new Date() - routeSubmitTime) / 1000}`);
      // console.log('routeSolution', routeSolution);
      // get directions
      const result = {
        ...route,
        solution: solution.routes[0].stops,
        geometry: directionsResult.geometry,
        prevDuration: route.duration,
        duration,
        prevDistance: route.distance,
        distance,
        stops: this.orderStops(route, solution),
      };

      this.optimizedRouteCache.set(problemKey, result);
      return result;
    } else {
      throw resp;
    }
  };

  orderStops(route, solution) {
    console.log(route.stops);
    const stopsDict = route.stops.reduce((stops, stop) => {
      stops[stop.id] = stop;
      return stops;
    }, {});

    const stopsOrdered = solution.routes[0].stops.slice(1).map(stop => {
      return stopsDict[stop.location];
    });

    console.log(stopsOrdered);
    return stopsOrdered;
  }

  async getOptimizeResult(id) {
    return new Promise((resolve, reject) => {
      const poll = setInterval(async () => {
        const job = await this.client.get(`/${id}`, { params });
        if (job.status === 202) {
          // console.debug('Job processing', job.data);
        } else if (job.status === 200) {
          console.debug('Job complete', job.data);
          clearInterval(poll);
          if (job.code === 'internal_error') {
            return reject(Error('Internal error!', job.data));
          }
          return resolve(job.data);
        } else {
          clearInterval(poll);
          reject(Error('Error processing job ' + job.status));
        }
      }, 500);
    });
  }
  // this takes the output of stopsToOptimize and optimizes all the routes
  async optimizeRoutes(routes) {
    // for each stop, start a request
    let solutions = routes.map(async route => {
      return await this.optimizeRoute(route);
    });
    return Promise.all(solutions);
  }
  prepareInput(stopsToOptimize, routes) {
    const modifiedRoutes = {};

    Object.entries(stopsToOptimize).map(([stopId, stopInfo]) => {
      const prevRoute = modifiedRoutes[stopInfo.prevRoute]
        ? modifiedRoutes[stopInfo.prevRoute]
        : routes.find(item => item.id == stopInfo.prevRoute);
      modifiedRoutes[stopInfo.prevRoute] = this.removeStopFromRoute(
        stopId,
        prevRoute
      );

      const nextRoute = modifiedRoutes[stopInfo.nextRoute]
        ? modifiedRoutes[stopInfo.nextRoute]
        : routes.find(item => item.id == stopInfo.nextRoute);
      modifiedRoutes[stopInfo.nextRoute] = this.addStopToRoute(
        this.getStopById(stopId, routes),
        nextRoute
      );
    });

    return Object.values(modifiedRoutes);
  }

  removeStopFromRoute(stopToRemove, route) {
    let routeCopy = Object.assign({}, route);
    routeCopy.stops = route.stops.filter(stop => stop.id != stopToRemove);
    return routeCopy;
  }

  // Let's be careful about references eh for undos. Latest stop lives in route NOT in App stops array
  addStopToRoute(stopToAdd, route) {
    if (!route) {
      console.warn(
        'received a null or undefined route as a destination for stop',
        stopToAdd
      );
      return;
    }
    let routeCopy = Object.assign({}, route);
    // is this necessary with how state is managed? Wasn't sure
    let stopCopy = Object.assign({}, stopToAdd);
    stopCopy.route_id = route.id;

    routeCopy.stops = route.stops.slice();
    routeCopy.stops.push(stopCopy);
    return routeCopy;
  }

  getStops(routes) {
    return routes
      .map(route => {
        return route.stops.map(stop => {
          return {
            route_id: route.id,
            ...stop,
          };
        });
      })
      .flat();
  }

  // UTILITIES should be moved somewhere but needs access to state
  getStopById(id, routes) {
    return this.getStops(routes).find(
      item => parseInt(item.id) === parseInt(id)
    );
  }

  constructor() {
    axiosRetry(this.client, { retries: 3 });
    // this.client.defaults.params = params; // also broken
    // this.optimizeRoute(stops);
  }
}

// module.exports = new OptimizationService();
export default new OptimizationService();
